export default __webpack_public_path__ + "static/media/invoice-icon.7b00c682.svg";